import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbaServidor, ItemNavegacaoServidor } from '../core/rotas/navegacao-servidor';
import { AlertaMensagemComponent } from '../shared/alerta-mensagem.component';
import { CabecalhoMarcaComponent } from '../shared/cabecalho-marca.component';
import { NavegacaoServidorComponent } from '../shared/navegacao-servidor.component';

@Component({
  selector: 'app-layout-servidor',
  standalone: true,
  imports: [CommonModule, CabecalhoMarcaComponent, AlertaMensagemComponent, NavegacaoServidorComponent],
  templateUrl: './layout-servidor.component.html'
})
export class LayoutServidorComponent {
  @Input() logo = '';
  @Input() iniciais = '';
  @Input() nome = '';
  @Input() agora = new Date();
  @Input() aba: AbaServidor = 'inicio';
  @Input() itens: ItemNavegacaoServidor[] = [];
  @Input() mensagem = '';

  @Output() selecionar = new EventEmitter<string>();
  @Output() sair = new EventEmitter<void>();
}

